import React from 'react';

const TermsConditions = () => {
  return (
     <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8 !pt-20">
      <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-6 sm:p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Terms & Conditions</h1>

        <div className="prose prose-lg max-w-none text-gray-700">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Use of Services</h2>
            
            <h3 className="text-xl font-medium text-gray-800 mb-3">1.1 Eligibility</h3>
            <ul className="list-disc pl-6 mb-4">
              <li>You must be at least 18 years old to use our services.</li>
              <li>By using our services, you confirm that all information provided is accurate, complete, and up to date.</li>
            </ul>

            <h3 className="text-xl font-medium text-gray-800 mb-3">1.2 Prohibited Activities</h3>
            <p className="mb-3">Users are prohibited from:</p>
            <ul className="list-disc pl-6 mb-4">
              <li>Engaging in any illegal activities.</li>
              <li>Misusing or tampering with our website, services, or systems.</li>
              <li>Attempting to gain unauthorized access to our systems or data.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Services Provided</h2>
            <p className="mb-4">
              AdroitOne Inc. provides recruitment, staffing, and technology services, including but not limited to executive search, contract staffing, and software/web development.
            </p>

            <h3 className="text-xl font-medium text-gray-800 mb-3">2.1 Recruitment and Staffing Services</h3>
            <ul className="list-disc pl-6 mb-4">
              <li>AdroitOne acts as a facilitator between employers and candidates. We do not guarantee employment or the duration of employment unless explicitly agreed in a contract.</li>
              <li>Employers and candidates are responsible for their contractual obligations.</li>
            </ul>

            <h3 className="text-xl font-medium text-gray-800 mb-3">2.2 Software and Web Development</h3>
            <p>For software and web development projects, a clear agreement regarding the scope of work, timelines, and payment terms must be signed before project initiation. Ownership of intellectual property will depend on the terms defined in the agreement.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Intellectual Property</h2>
            
            <h3 className="text-xl font-medium text-gray-800 mb-3">3.1 Ownership</h3>
            <p className="mb-4">
              All content on our website, including but not limited to text, images, logos, and software, is the intellectual property of AdroitOne Inc. or its licensors. Unauthorized use is strictly prohibited.
            </p>

            <h3 className="text-xl font-medium text-gray-800 mb-3">3.2 User-Generated Content</h3>
            <p>By submitting content to AdroitOne (e.g., resumes or project briefs), you grant us a non-exclusive, royalty-free license to use the content for providing our services.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Limitation of Liability</h2>
            
            <h3 className="text-xl font-medium text-gray-800 mb-3">4.1 No Warranties</h3>
            <p className="mb-4">
              AdroitOne provides services on an "as-is" basis. We make no warranties, express or implied, regarding the accuracy, reliability, or suitability of our services.
            </p>

            <h3 className="text-xl font-medium text-gray-800 mb-3">4.2 No Liability for Indirect Damages</h3>
            <p>To the maximum extent permitted by law, AdroitOne shall not be held liable for any indirect, incidental, or consequential damages arising from the use of our services.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Payment Terms</h2>
            
            <h3 className="text-xl font-medium text-gray-800 mb-3">5.1 Payment for Services</h3>
            <ul className="list-disc pl-6 mb-4">
              <li>All payments for our recruitment, staffing, or development services must be made as per the agreed terms.</li>
              <li>Late payments may incur additional charges.</li>
            </ul>

            <h3 className="text-xl font-medium text-gray-800 mb-3">5.2 Refund Policy</h3>
            <p>Refunds, if applicable, will be provided based on the specific service agreement. Recruitment and development fees are non-refundable unless explicitly stated.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. User Responsibilities</h2>
            
            <h3 className="text-xl font-medium text-gray-800 mb-3">6.1 Account Security</h3>
            <p className="mb-4">Users are responsible for maintaining the confidentiality of their account credentials and all activities under their account.</p>

            <h3 className="text-xl font-medium text-gray-800 mb-3">6.2 Compliance with Laws</h3>
            <p>You agree to comply with all applicable laws and regulations while using our services.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Third-Party Links and Services</h2>
            <p>Our website or services may contain links to third-party websites. AdroitOne is not responsible for the content, policies, or practices of these external sites. We recommend reviewing the terms and privacy policies of third-party websites.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Termination</h2>
            <p>AdroitOne reserves the right to terminate your access to our services without notice if you violate these Terms and Conditions or engage in unauthorized activities.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Governing Law and Jurisdiction</h2>
            <p>These Terms and Conditions are governed by and construed in accordance with the laws of the State of New York. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts in New York, NY.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Modifications to Terms</h2>
            <p>AdroitOne reserves the right to update or modify these Terms and Conditions at any time. Changes will be effective upon posting the updated version on our website. Continued use of our services after changes constitutes acceptance of the revised terms.</p>
          </section>

          <section className="mt-12 p-6 bg-blue-50 rounded-lg border-l-4 border-blue-500">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Contact Information</h2>
            <p className="mb-4">If you have any questions about these Terms and Conditions, please contact us:</p>
            <div className="text-gray-700">
              <p className="font-medium text-lg">AdroitOne Inc.</p>
              <p className="mb-2">Email: <a href="mailto:contact@adroitone.com" className="text-blue-600 hover:underline">contact@adroitone.com</a></p>
              <p>Address: 245 East Gun Hill Road, New York City, NY 10467</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;